import { render, staticRenderFns } from "./controllers.vue?vue&type=template&id=87f0751c&scoped=true"
import script from "./controllers.vue?vue&type=script&lang=js"
export * from "./controllers.vue?vue&type=script&lang=js"
import style0 from "./controllers.vue?vue&type=style&index=0&id=87f0751c&prod&lang=scss&scoped=true"
import style1 from "./controllers.vue?vue&type=style&index=1&id=87f0751c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f0751c",
  null
  
)

export default component.exports